export default __webpack_public_path__ + "static/media/023-rainbow.fd1f2396.svg";